<template>
    <rkm-overlay>
        <rkm-layout-body title="Listagem de transporte agendado">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                    v-if="!isDisabled"
                >
                    Salvar
                </rkm-button>
                <rkm-button
                    @click="$refs.Form.defaultPrint()"
                    color="info"
                    v-if="!isDisabled"
                >
                    {{ `${ status == enums.status.FINALIZADO ? '' : 'Salvar e '}Imprimir` }}
                </rkm-button>
                <rkm-button
                    @click="$refs.Form.simplePrint()"
                    color="secondary"
                    v-if="!isDisabled"
                >
                    {{ `${ status == enums.status.FINALIZADO ? '' : 'Salvar e '}Imprimir Simplificado` }}
                </rkm-button>
                <rkm-button
                    @click="$refs.Form.exportTo()"
                    color="success"
                    v-if="!isDisabled"
                >
                    {{ `${ status == enums.status.FINALIZADO ? '' : 'Salvar e '}Exportar` }}
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List
                    ref="Form"
                    @setPrintable="setPrintable"
                    @setStatus="setStatus"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/transporte-paciente/listagem/List'

import { mapActions } from 'vuex';

import status from '@/enums/transporte-paciente/status'

export default {
    components: { List },
    data: () => ({
        isDisabled: true,
        status: 1,
        enums: {
            status
        }
    }),
    created() {
        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        handleExit() {
            this.$router.push({ name: 'dashboard' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        setPrintable(value) {
            this.isDisabled = value
        },
        setStatus(value) {
            this.status = value
        }
    },
}
</script>